import React from "react";
import { HashRouter as Router, Routes, Route, Link } from "react-router-dom";
import "./index.css";
import Landing from "pages/Landing/Landing";
import Dashboard from "pages/Dashboard/Dashboard";
import SingleBlog from "components/Blogs/SingleBlog";
import Login from "pages/Login/Login";
import PageNotFound from "components/PageNotFound/PageNotFound";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/blog-post/:id" element={<SingleBlog />} />
      <Route path="/admin-login" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/*" element={<PageNotFound />} />
    </Routes>
  );
}

export default App;
